import React from 'react';

import { isIOS } from 'react-device-detect';
import { useTranslation } from 'react-i18next';

import { ReactComponent as ExternalLinkIcon } from '@pkg/assets/icons/v1/external-link.svg';
import { ReactComponent as InfoIcon } from '@pkg/assets/icons/v1/info.svg';

import './Footer.scss';

const gaGPlayLink = 'https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en&gl=US';
const authyGPlayLink = 'https://play.google.com/store/apps/details?id=com.authy.authy';
const gaAppStoreLink = 'https://apps.apple.com/us/app/google-authenticator/id388497605';
const authyAppStoreLink = 'https://apps.apple.com/us/app/authy/id494168017';

export const AuthFlowFooter = () => {
    const { t } = useTranslation(['twoFactorAuth']);

    return (
        <>
            <h3 className="auth-flow-footer__title">
                <span>
                    <InfoIcon />
                </span>
                <span dangerouslySetInnerHTML={{ __html: t('2fa_flow_footer_title') }} />
            </h3>
            <p className="auth-flow-footer__detail" dangerouslySetInnerHTML={{ __html: t('2fa_flow_footer_detail') }} />
            <ul className="auth-flow-footer__links">
                <li>
                    {/* eslint-disable react/jsx-no-target-blank */}
                    <a
                        href={isIOS ? gaAppStoreLink : gaGPlayLink}
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer nofollow"
                    >
                        <span>{t('2fa_flow_footer_ext_link1')}</span>
                        <span className="icon">
                            <ExternalLinkIcon />
                        </span>
                    </a>
                    {/* eslint-enable react/jsx-no-target-blank */}
                </li>
                <li>
                    {/* eslint-disable react/jsx-no-target-blank */}
                    <a
                        href={isIOS ? authyAppStoreLink : authyGPlayLink}
                        target="_blank"
                        className="link"
                        rel="noopener noreferrer nofollow"
                    >
                        <span className="circle" />
                        <span>{t('2fa_flow_footer_ext_link2')}</span>
                        <span className="icon">
                            <ExternalLinkIcon />
                        </span>
                    </a>
                    {/* eslint-enable react/jsx-no-target-blank */}
                </li>
            </ul>
        </>
    );
};
